import { AD_COUNT_KEYS } from '../constants/salonOffer'

export default function resolveAvailableListContent (enabledContent, availableContentAdCounts) {
    return ['all'].concat(Object
        .keys(enabledContent))
        // .filter(key => enabledContent[key] === true)
        .filter(key => Boolean(availableContentAdCounts[AD_COUNT_KEYS[key]]))
}